import {
  WorkflowFormFieldOutputFiles,
  WorkflowFormFieldOutputFilesPopulated,
} from './list/outputFiles';
import {
  WorkflowFormFieldOutputHint,
  WorkflowFormFieldOutputHintPopulated,
} from './list/outputHint';
import {
  WorkflowFormFieldOutputRequestComments,
  WorkflowFormFieldOutputRequestCommentsPopulated,
} from './list/outputRequestComments';
import {
  WorkflowFormFieldOutputRequestField,
  WorkflowFormFieldOutputRequestFieldPopulated,
} from './list/outputRequestField';
import {
  WorkflowFormFieldOutputText,
  WorkflowFormFieldOutputTextPopulated,
} from './list/outputText';
import {
  WorkflowFormFieldOutputLink,
  WorkflowFormFieldOutputLinkPopulated,
} from './list/outputLink';
import {
  WorkflowFormFieldOutputRequestFileCats,
  WorkflowFormFieldOutputRequestFileCatsPopulated,
} from './list/outputRequestFileCats';

// Поля, которые настраиваются в конструкторе, и не заполняются в форме
export type WorkflowFormFieldOutput =
  | WorkflowFormFieldOutputText
  | WorkflowFormFieldOutputRequestField
  | WorkflowFormFieldOutputRequestFileCats
  | WorkflowFormFieldOutputHint
  | WorkflowFormFieldOutputRequestComments
  | WorkflowFormFieldOutputFiles
  | WorkflowFormFieldOutputLink;

// Те же поля, что выше, но уже для отображении в конкретной форме регламента (дополненные данными)
export type WorkflowFormFieldOutputPopulated =
  | WorkflowFormFieldOutputTextPopulated
  | WorkflowFormFieldOutputRequestFieldPopulated
  | WorkflowFormFieldOutputRequestFileCatsPopulated
  | WorkflowFormFieldOutputHintPopulated
  | WorkflowFormFieldOutputRequestCommentsPopulated
  | WorkflowFormFieldOutputFilesPopulated
  | WorkflowFormFieldOutputLinkPopulated;

export const WORKFLOW_FORM_FIELD_OUTPUT_TYPES = {
  outputFiles: 'outputFiles',
  outputHint: 'outputHint',
  outputLink: 'outputLink',
  outputRequestComments: 'outputRequestComments',
  outputRequestField: 'outputRequestField',
  outputRequestFileCats: 'outputRequestFileCats',
  outputText: 'outputText',
} as const;
